var _line, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeGrid({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: 4,
    x2: 6,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 4,
    x2: 18,
    y2: 20
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeGrid);
export default __webpack_public_path__ + "static/media/threeGrid.411406e37c1ac0a2c5c54743a7a81aba.svg";
export { ForwardRef as ReactComponent };